<template>
  <div id="app" class="appAll">



      <hearder ref="head"></hearder>
    <router-view :key="$route.fullPath + Date.now()"/>




      <Footer ref="foot"></Footer>




  </div>
</template>

<script>
import hearder from './components/hearder.vue'
import hearderEn from './components/en/hearder.vue'
import FooterEn from './components/en/Footer.vue'
import Footer from './components/Footer.vue'
import axios from 'axios';
import {Data} from "./components/js/header";
export default {
  name: 'App',
  data() {
    return {
      path: "",
      message:"zh",
      hearderData:Data
    }
  },
  components: {
    Footer,
    hearder,
  },
  mounted() {
    this.path = this.$route.path; /*this.path 为当前页面的路由 */

  },
  created() {
    // let that = this;
    // let pathFrom = that.$route.path;
    // if(pathFrom.startsWith("/en")){
    //   that.message = 'en';
    // } else {
    //   that.message = 'zh';
    // }
  },
  methods: {
  },
  /*监测路由的变化 */
  watch: {
    $route(to, from) {
      this.path = to.path;
      let that = this;
      let headItem =[];
      for(let index in that.hearderData){
        let itemData= that.hearderData[index];
        if(that.message == itemData.type){
          headItem = itemData.menuData;
          break;
        }
      }
      for(let item in headItem){
        let itemData =  headItem[item]
        if(that.path == itemData.headPath){
          console.log("head:"+ itemData.headIndex)
          hearder.data().activeIndex = itemData.headIndex;
        }
      }
      this.$refs.head.choiceEn();
      this.$refs.foot.choiceEn();
    }


  },

}
</script>

<style>
.appAll{
  width: 100%;
}
a{text-decoration: none;}
.hearder {
  border: 1px red solid;

}
body{
    background-color: aliceblue;
}
</style>



// WEBPACK FOOTER //
// src/App.vue